import { render, staticRenderFns } from "./Folder.vue?vue&type=template&id=6e4700f4&scoped=true&"
import script from "./Folder.vue?vue&type=script&setup=true&lang=js&"
export * from "./Folder.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4700f4",
  null
  
)

export default component.exports